class CustomFileInput {
	constructor (el) {
		this.el = el
		this.fakeInput = this.el.nextElementSibling

		if (!this.fakeInput || this.fakeInput.tagName.toLowerCase() !== 'label') {
			throw Error('Custom file input must be immediately succeeded by a <label> element');
		}

		this.feedback = this.fakeInput.lastElementChild

		this._handleInputChange = this._handleInputChange.bind(this)
		this.el.addEventListener('change', this._handleInputChange)
		this.initialFeedback = this.feedback.textContent
	}
	_handleInputChange (event) {
		const input = this.el
		const { value, files } = input
		const template = this.feedback.getAttribute(files && files.length > 1 ? 'data-multiple-caption' : 'data-single-caption')
		let feedback = ''

		if (files && files.length > 0) {
			feedback = template.replace('{count}', files.length) + '\n' + Array.from(files)
				.map(file => file.name)
				.join(', ')
		} else {
			feedback = value.split('\\').pop()
		}
		if (feedback) {
			this.feedback.textContent = feedback
		} else {
			this.feedback.textContent = this.initialFeedback
		}
	}
}

export default CustomFileInput
